export default function wrapIndex(indexable, index) {
  if (!indexable || !indexable.length) {
    return -1;
  }

  const normalizedIndex = index % indexable.length;
  return normalizedIndex >= 0
    ? normalizedIndex
    : indexable.length + normalizedIndex;
}